import { SubscriptionBillingCadence } from '@houzy/schemas/partner-management/partner-subscription-management';
import type { TFunction } from 'i18next';

export function subscriptionCadenceLabel(t: TFunction, billingCadence: SubscriptionBillingCadence): string {
    return t(
        billingCadence === SubscriptionBillingCadence.Monthly
            ? 'CHECKOUT.PLAN.BILLED_MONTHLY'
            : 'CHECKOUT.PLAN.BILLED_UPFRONT',
    );
}
